<script setup lang="ts">
import { useLoanAppProcess } from '@/helpers/useLoanAppProcess';
import { CustomerApplicationProcessStep } from '@/types';
import SummaryDetails from './modules/Summary/SummaryDetails.vue';

const { isSaving, submitStep, saveAndGoNext } = useLoanAppProcess();

const saveAndContinue = () => submitStep(CustomerApplicationProcessStep.Summary, () => saveAndGoNext());
</script>

<template>
  <div>
    <div class="mb-4 pb-2">
      <h2 class="text-2xl font-medium">
        <BxHighlight>Review summary</BxHighlight>
      </h2>
    </div>
    <div class="my-8">
      <SummaryDetails />
    </div>
    <div class="mt-12">
      <BxButton variant="primary" :loading="isSaving" @click="saveAndContinue()">Next</BxButton>
    </div>
  </div>
</template>
